import React from 'react';
import { selectOverview } from '../../../../util/store/selectors';
import { useSelector } from "../../../../util/store/store";
import { ILevel, IPropsChildren } from "../../../../util/varibles/interface";
import { IVesselHeight } from "../Vessels";
import Operation from './Operation';

export interface IPropsOp extends ICommon {
    level: ILevel
}

export interface ICommon extends IPropsChildren {
    vesselHeight: IVesselHeight
}

interface IProps {
    vesselHeight: IVesselHeight
}

const Operations: React.FC<IProps> = ({ vesselHeight }) => {
    const operations = useSelector(selectOverview.ops);
    const level = useSelector(selectOverview.level);

    return <>
        {Object.keys(operations).map(key => {
            const op = operations[key];
            return <Operation
                key={key}
                data={op}
                level={level[op.vessel.id][op.operation.id]}
                vesselHeight={vesselHeight}
            />
        })}
    </>
};

export default Operations;
